var initFade = function initFade(container) {
	var scope = container || document;
	var fades = scope.querySelectorAll('.fade-up');
	var st = window.ScrollTrigger_ScrollTrigger || window.ScrollTrigger;
	var gsapEngine = window.gsapWithCSS || window.gsap;
	if (!gsapEngine || !st) return;

	st.update();
	fades.forEach(function (el) {
		if (el.classList.contains('gsap-init')) return;
		el.classList.add('gsap-init');
		el.style.opacity = '0';

		var delay = el.dataset.delay ? parseFloat(el.dataset.delay) : 0;

		gsapEngine.to(el, {
			opacity: 1,
			y: 0,
			duration: 0.6,
			delay: delay,
			ease: 'power1.out',
			scrollTrigger: {
				trigger: el,
				scroller: document.querySelector('[data-scroll-container]') || window,
				start: 'top 80%'
			}
		});
	});
};

const initRelatedProductsSlider = (root = document) => {
	const slider = root.querySelector('.js-other-products__slider');

	if (!slider || !window.Swiper) {
		if (slider && !window.Swiper) console.warn('Swiper not found');
		return;
	}

	if (slider.swiper) {
		slider.swiper.destroy(true, true);
	}

	const prevEl = slider.querySelector('.slider-nav__arrow.--prev');
	const nextEl = slider.querySelector('.slider-nav__arrow.--next');
	const paginationEl = slider.querySelector('.slider-pagination');

	new window.Swiper(slider, {
		observer: true,
		observeParents: true,
		watchOverflow: true,
		resizeObserver: true,
		slidesPerView: 1,
		spaceBetween: 8,
		navigation: {
			prevEl,
			nextEl
		},
		pagination: {
			el: paginationEl,
			clickable: true,
			type: 'bullets'
		},
		breakpoints: {
			766: { slidesPerView: 2, spaceBetween: 12 },
			1080: { slidesPerView: 2, spaceBetween: 16 },
			1280: { slidesPerView: 3, spaceBetween: 20 },
			1780: { slidesPerView: 4, spaceBetween: 20 }
		},
	});
};

if (!customElements.get('product-recommendation')) {
	customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			if (!this.dataset.url) return;

			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					this.renderSection();
					observer.disconnect();
				}
			}, { rootMargin: '200px' });

			observer.observe(this);
		}

		async renderSection() {
			try {
				const response = await fetch(this.dataset.url);
				if (!response.ok) return;

				const text = await response.text();
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const newContent = doc.querySelector('[data-product-list]');
				const currentWrapper = this.querySelector('[data-product-list]');

				if (newContent && currentWrapper && newContent.innerHTML.trim().length > 0) {
					currentWrapper.innerHTML = newContent.innerHTML;
					this.style.display = 'block';

					// Підготовка до анімації
					const fades = this.querySelectorAll('.fade-up');
					fades.forEach(el => {
						el.style.opacity = '0';
						el.classList.remove('gsap-init', 'gsap-initialized');
					});

					requestAnimationFrame(() => {
						initRelatedProductsSlider(this);

						if (window.lazyLoadEnabled === "true" && typeof window.reloadLazyLoad === 'function') {
							window.reloadLazyLoad();
						}

						setTimeout(() => {
							if (typeof initFade === 'function') {
								initFade(this);
								fades.forEach(el => el.classList.add('gsap-initialized'));
							}
						}, 100);
					});

				} else {
					this.style.display = 'none';
				}

			} catch (err) {
				console.error(err);
				this.style.display = 'none';
			}
		}
	});
}